var _effectorFileName = "/builds/gmini/front-ui-kit/src/SeparatorList/SeparatorList.tsx";
import { Item, List } from './SeparatorList.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const SeparatorList = ({
  children,
  ...other
}) => /*#__PURE__*/_jsx(List, { ...other,
  children: children instanceof Array ? children.filter(Boolean).map((item, idx) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _jsx(Item, {
    children: item
  }, idx)) : /*#__PURE__*/_jsx(Item, {
    children: children
  })
});